<div class="wrapper">
    <div class="input-box-wrapper" [ngClass]="{ 'disabled-input': isInputDisabled }">
        <div class="checkbox-type" *ngIf="inputType === 'checkbox'">
            <div class="value">
                <app-checkbox
                    [(checked)]="inputModel"
                    (checkedChange)="inputModelChange.emit(inputModel)"
                >
                </app-checkbox>
            </div>
            <div class="label-content">
                {{ label }}
            </div>
        </div>

        <div class="input-type" *ngIf="inputType !== 'checkbox'">
            <div class="label-content">
                {{ label }}
            </div>
            <div class="value">
                <input
                    [type]="inputType"
                    [(ngModel)]="inputModel"
                    (ngModelChange)="inputModelChange.emit(inputModel)"
                    [disabled]="isInputDisabled"
                    [checked]="isCheck"
                />
            </div>
        </div>
        <div *ngIf="note" class="note">
            {{ note }}
        </div>
        <a
            class="link"
            *ngIf="linkTarget"
            [target]="isLinkExternal ? '_blank' : '_self'"
            rel="noopener noreferrer"
            [href]="linkTarget"
            (click)="linkClicked.emit($event)"
        >
            {{ linkLabel }}
            <em *ngIf="isLinkExternal" class="fas fa-external-link-alt"></em>
        </a>
    </div>
</div>
